import { useLingui } from '@lingui/react/macro';

import { TOfferDataRequirement } from '../../../../../types';
import DocumentRequirement from '../../../DocumentRequirement/DocumentRequirement';
import { documentTypes } from '../../../tradingHistory.helpers';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};
export const Bwa = ({ isOptional, isSubmitted, status }: TProps) => {
  const { t } = useLingui();

  return (
    <DocumentRequirement
      title={t`Current BWA`}
      documentType={documentTypes.bwa_hochladen}
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <>
        <ul>
          <li>
            Sie können sich die BWA aus Ihrer Buchhaltungssoftware herunterladen
            oder bei Ihrem Steuerberater anfragen
          </li>
          <li>
            Alle BWAs sollten Firmenname, Umsatzerlöse, Wareneinkauf, Kosten
            inkl. Abschreibungen, Zinsaufwände & vorläufiges Ergebnis zeigen
          </li>
        </ul>
      </>
    </DocumentRequirement>
  );
};
